import React, { lazy, PureComponent, Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { s as styleInject } from './style-inject.es-746bb8ed.js';
import { TextInput } from 'wix-rich-content-ui-components';
import { mergeStyles } from 'wix-rich-content-common';
import { isUndefined } from 'lodash';

var css_248z = ".bujeP,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.vjRZ4{align-items:center;bottom:0;display:flex;justify-content:center;position:fixed;top:0;z-index:5}[dir] .vjRZ4{background-color:rgba(0,0,0,.5)}[dir=ltr] .vjRZ4{left:0;right:0}[dir=rtl] .vjRZ4{left:0;right:0}.-sYoN{color:var(--ricos-settings-text-color,#000);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:14px;font-stretch:normal;font-style:normal;font-weight:300;min-width:360px;position:relative}[dir] .-sYoN{padding:12px}.-sYoN.O9PZ5{align-items:center;max-width:420px}[dir] .-sYoN.O9PZ5{margin:0}.MyAzo{flex-direction:column-reverse;min-width:0;width:100%}[dir] .MyAzo{padding:0}.MyAzo.O9PZ5,.Z6C9K{width:100%}[dir] .Z6C9K{padding:0}@media only screen and (max-width:640px){.Z6C9K{width:calc(100% - 40px)}[dir] .Z6C9K{margin:0 auto}}.Z6C9K .O9PZ5{height:40px}._7QBSN{color:var(--ricos-settings-text-color,#333);font-size:14px;font-stretch:normal;font-style:normal;font-weight:300;letter-spacing:normal;line-height:1.5}[dir] ._7QBSN{margin:0 1px;padding-bottom:6px}[dir=ltr] ._7QBSN{text-align:left}[dir=rtl] ._7QBSN{text-align:right}[dir] ._7QBSN.O9PZ5{margin:0;padding:0}.Xqi9-{position:relative;width:100%}[dir] .Xqi9-{margin:0 0 20px}[dir] .Xqi9- .O9PZ5{margin:0}[dir=ltr] .Zz2YT{margin-left:0}[dir=rtl] .Zz2YT{margin-right:0}.f4ya0,.uXMD0{color:var(--ricos-settings-text-color,#333);font-size:14px;width:100%}[dir] .f4ya0,[dir] .uXMD0{border:1px solid var(--ricos-settings-inputs-border-color,rgba(51,51,51,.2))}[dir] .f4ya0:focus,[dir] .f4ya0:focus+.uXMD0,[dir] .uXMD0:focus,[dir] .uXMD0:focus+.uXMD0{border:1px solid var(--ricos-settings-inputs-border-color,rgba(51,51,51,.5))}.f4ya0{box-sizing:border-box;height:40px}[dir] .f4ya0{border:1px solid var(--ricos-settings-inputs-border-color,rgba(0,0,0,.6));border-radius:var(--ricos-settings-inputs-border-radius,0);padding:0 18px}[dir=ltr] .f4ya0{text-align:left}[dir=rtl] .f4ya0{text-align:right}.f4ya0::placeholder{color:var(--ricos-settings-inputs-placeholder-color,rgba(0,0,0,.4))}.uXMD0{position:absolute!important}[dir] .uXMD0{border-top:0!important}[dir] .aLObq{border:1px solid red!important}._6m9LF{color:var(--ricos-settings-text-color,#333);height:42px;width:100%}[dir] ._6m9LF{border:1px solid #ededed;padding:0 17px}.xkHgy{bottom:0;position:absolute;top:0;width:13px}[dir] .xkHgy{margin:auto}[dir=ltr] .xkHgy{right:12px}[dir=rtl] .xkHgy{left:12px}._5K1Ck{position:relative;width:calc(100% + 24px)}[dir] ._5K1Ck{border-bottom:1px solid var(--ricos-settings-dividers-color,rgba(51,51,51,.1))}[dir=ltr] ._5K1Ck{left:-12px}[dir=rtl] ._5K1Ck{right:-12px}.-sYoN.O9PZ5,.MyAzo{display:flex;gap:12px}[dir] .pAcLA{margin-bottom:12px}";
var styles = {"fontElementMap":"bujeP","linkPanel_overlay":"vjRZ4","linkPanel_container":"-sYoN","basicPanel":"O9PZ5","linkPanel_container_isMobile":"MyAzo","linkPanel_wrapper":"Z6C9K","linkPanel_Content":"_7QBSN","linkPanel_Input":"Xqi9-","checkboxesContainer":"Zz2YT","linkPanel_textInput":"f4ya0","linkPanel_dropdownList":"uXMD0","linkPanel_textInput_invalid":"aLObq","linkPanel_imageSettings":"_6m9LF","linkPanel_errorIcon":"xkHgy","linkPanel_actionsDivider":"_5K1Ck","linkPanel_checkbox":"pAcLA"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const List = lazy(
  () => import('react-window').then(({ FixedSizeList }) => ({
    default: FixedSizeList
  }))
);
const Downshift = lazy(() => import('downshift'));
function isSubString(str, subStr) {
  return str.toLowerCase().includes(subStr.toLowerCase());
}
function filterItems(items, str) {
  return str ? items.filter(({ value, label }) => isSubString(value, str) || isSubString(label, str)) : items;
}
class ItemRenderer extends PureComponent {
  render() {
    const { items, getItemProps, highlightedIndex, selectedItem, formatMenuItem, inputValue } = this.props.data;
    const { index, style } = this.props;
    const item = items[index];
    return /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({}, getItemProps({
        item,
        index,
        key: item.value,
        style: __spreadValues({
          backgroundColor: highlightedIndex === index ? "lightgray" : "white",
          fontWeight: selectedItem === item ? "bold" : "normal"
        }, style)
      })),
      formatMenuItem(item, inputValue)
    );
  }
}
__publicField(ItemRenderer, "propTypes", {
  data: PropTypes.object,
  index: PropTypes.number,
  style: PropTypes.object
});
class LinkPanelDropdown extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      selectedItem: { value: this.props.value },
      items: this.props.getItems(),
      fallbackChanged: false
    });
    __publicField(this, "textInput", React.createRef());
    __publicField(this, "styles", mergeStyles({ styles, theme: this.props.theme }));
    __publicField(this, "handleDropDownStateChange", (changes) => {
      if (!isUndefined(changes.selectedItem)) {
        this.setState({ selectedItem: changes.selectedItem });
      }
      if (!isUndefined(changes.inputValue)) {
        const { inputValue } = changes;
        if (!this.state.selectedItem || this.state.selectedItem.value !== inputValue) {
          this.setState({ selectedItem: { value: inputValue } });
        }
        this.setState({
          items: filterItems(this.props.getItems(), inputValue),
          inputValue
        });
        this.props.onChange(inputValue);
      }
    });
  }
  render() {
    const { itemToString, formatMenuItem, itemHeight, textInputProps, value, t } = this.props;
    const { selectedItem, items, fallbackChanged } = this.state;
    return /* @__PURE__ */ React.createElement(
      Suspense,
      {
        fallback: /* @__PURE__ */ React.createElement(
          Input,
          __spreadProps(__spreadValues({}, textInputProps), {
            value,
            onChange: (e) => {
              this.props.onChange(e.target.value);
              this.setState({ fallbackChanged: true });
            },
            placeholder: t("LinkPanel_InputPlaceholder"),
            selectText: true
          })
        )
      },
      /* @__PURE__ */ React.createElement(
        Downshift,
        {
          selectedItem,
          onStateChange: this.handleDropDownStateChange,
          itemToString,
          initialInputValue: value
        },
        ({
          getInputProps,
          getItemProps,
          // getLabelProps,
          getMenuProps,
          isOpen,
          highlightedIndex,
          inputValue
        }) => {
          const inputProps = getInputProps(__spreadValues({}, textInputProps));
          return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
            Input,
            __spreadProps(__spreadValues({}, getInputProps(__spreadValues({}, inputProps))), {
              selectText: !fallbackChanged,
              placeholder: t("LinkPanel_InputPlaceholder")
            })
          ), (isOpen || this.props.isOpen) && List && /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(
            List,
            __spreadValues({
              className: styles.linkPanel_dropdownList,
              height: Math.min(items.length * itemHeight + 1, 200),
              itemCount: items.length,
              itemSize: itemHeight,
              itemData: {
                items,
                getItemProps,
                highlightedIndex,
                selectedItem,
                formatMenuItem,
                inputValue
              }
            }, getMenuProps()),
            ItemRenderer
          )));
        }
      )
    );
  }
}
__publicField(LinkPanelDropdown, "propTypes", {
  theme: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  getItems: PropTypes.func,
  t: PropTypes.func,
  itemToString: PropTypes.func,
  value: PropTypes.string,
  formatMenuItem: PropTypes.func,
  itemHeight: PropTypes.number,
  textInputProps: PropTypes.object,
  isOpen: PropTypes.bool
});
class Input extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "textInput", React.createRef());
  }
  componentDidMount() {
    const { selectText } = this.props;
    const ref = this.textInput.current;
    ref.focus();
    if (selectText) {
      ref.select();
    } else {
      ref.selectionStart = ref.selectionEnd = ref.value.length;
    }
  }
  render() {
    const _a = this.props, { placeholder, selectText } = _a, inputProps = __objRest(_a, ["placeholder", "selectText"]);
    return /* @__PURE__ */ React.createElement(
      TextInput,
      __spreadProps(__spreadValues({}, inputProps), {
        inputRef: this.textInput,
        onChange: (value) => inputProps.onChange({ target: { value } }),
        placeholder
      })
    );
  }
}

export { LinkPanelDropdown as L, styles as s };
//# sourceMappingURL=LinkPanelDropdown-5fd0111d.js.map
